import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { BellOutlined, PhoneOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';
import { getNodes } from 'utils/paginationHelper';
import { Button } from 'ui/styled';
import { BLUE, RED, GREEN_DARK, WHITE, GREY_SECONDARY } from 'ui/constants';
import { message, Spin } from 'antd';
import { useMembersForNicQuery } from 'apollo/queries/NIC/MEMBERS_FOR_NIC';
import { isIncoming } from 'pages/NIC/hooks/useCallStates';
import { selectCalls, useCallStore } from 'stores/nic/stores/callStore';
import { selectAgents, useContactStore } from 'stores/nic/stores/contactStore';
import { selectIsAcceptingCall, useNicStore } from 'stores/nic/stores/nicStore';
import { useNicService } from 'stores/nic/useNicService';
import { DirectoryEntities } from '@nice-devone/common-sdk';
import MemberInfo from './MemberInfo';
import { IncomingInfo, BellWrapper, ButtonsContainer, PhoneNumber } from './styled';
var IncomingView = function () {
    var _a;
    var _b = useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    var agents = useContactStore(selectAgents);
    var calls = useCallStore(selectCalls);
    var callIndex = calls.findIndex(function (c) { var _a; return isIncoming((_a = c.call) === null || _a === void 0 ? void 0 : _a.status); });
    var currentCall = (_a = calls[callIndex]) === null || _a === void 0 ? void 0 : _a.call;
    var ani = (currentCall === null || currentCall === void 0 ? void 0 : currentCall.ani) || '';
    var isAcceptingCall = useNicStore(selectIsAcceptingCall);
    var _c = useNicService(), acceptIncomingCall = _c.acceptIncomingCall, rejectIncomingCall = _c.rejectIncomingCall;
    var loadDirectoryData = useNicService().loadDirectoryData;
    var setCalls = useCallStore().setCalls;
    useEffect(function () {
        var cleanup = loadDirectoryData({
            entity: [
                DirectoryEntities.AGENT_LIST,
                DirectoryEntities.SKILL_LIST,
                DirectoryEntities.TEAM_LIST
            ]
        });
        return function () { return cleanup && cleanup(); };
    }, [loadDirectoryData]);
    var agentContact = agents === null || agents === void 0 ? void 0 : agents.find(function (item) { var _a; return ((_a = item.agentId) === null || _a === void 0 ? void 0 : _a.toString()) === ani; });
    var _d = useMembersForNicQuery({
        variables: {
            filters: {
                phone_search: ani
            }
        },
        skip: !!agentContact
    }), data = _d.data, loading = _d.loading;
    var members = getNodes(['members'])(data);
    if (loading)
        return _jsx(Spin, {});
    return (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', padding: 16 }, children: [(currentCall === null || currentCall === void 0 ? void 0 : currentCall.skillName) ? (_jsxs("span", { style: { fontSize: 14, fontWeight: 600 }, children: ["Skill: ", currentCall.skillName] })) : null, _jsxs(IncomingInfo, { children: [_jsx("div", { children: _jsx(BellWrapper, { children: _jsx(BellOutlined, { style: { fontSize: 24, color: BLUE } }) }) }), agentContact && (_jsxs("span", { style: { fontSize: 14, fontWeight: 600 }, children: [agentContact === null || agentContact === void 0 ? void 0 : agentContact.firstName, " ", agentContact === null || agentContact === void 0 ? void 0 : agentContact.lastName] })), members.length === 1 ? (_jsx(MemberInfo, { member: members[0] })) : (_jsxs("div", { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: ani ? 4 : 0
                        }, children: [_jsx(PhoneNumber, { children: ani }), !!members.length && (_jsxs("button", { type: "button", style: {
                                    color: GREY_SECONDARY,
                                    cursor: 'pointer',
                                    fontWeight: 600,
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    font: 'inherit'
                                }, onClick: function () { return setIsExpanded(!isExpanded); }, children: ["Multiple Matches (", members.length, ")", ' ', isExpanded ? _jsx(UpOutlined, {}) : _jsx(DownOutlined, {})] }))] })), _jsxs(ButtonsContainer, { children: [members.length !== 1 && !agentContact && (_jsx(Button, { btnsize: "custom", padding: "12px 24px", onClick: function () {
                                    return window.open("/members?phone_search=".concat(encodeURIComponent(ani)), '_blank', 'noopener,noreferrer');
                                }, children: "Search" })), _jsxs(Button, { btntype: "custom", btnsize: "custom", bgcolor: RED, color: WHITE, border: "none", padding: "12px 24px", onClick: function () { return rejectIncomingCall(callIndex); }, children: [_jsx(PhoneOutlined, { style: { rotate: '-135deg' } }), "Reject"] }), _jsxs(Button, { btntype: "custom", btnsize: "custom", bgcolor: GREEN_DARK, color: WHITE, border: "none", padding: "12px 24px", loading: isAcceptingCall, onClick: function () {
                                    var contactID = currentCall === null || currentCall === void 0 ? void 0 : currentCall.contactID;
                                    if (!contactID) {
                                        message.error('Contact ID was not found');
                                        return;
                                    }
                                    if (agentContact)
                                        setCalls({ index: callIndex, agentInfo: agentContact });
                                    if (members.length === 1)
                                        setCalls({ index: callIndex, memberInfo: members[0] });
                                    return acceptIncomingCall(contactID);
                                }, children: [_jsx(PhoneOutlined, {}), "Accept"] })] })] }), isExpanded
                ? members.map(function (item) { return (_jsx(MemberInfo, { member: item, isList: true }, item === null || item === void 0 ? void 0 : item.id)); })
                : null] }));
};
export default IncomingView;
